import * as React from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";

function AppShell({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="app-shell"
      className={cn("relative isolate flex min-h-svh flex-col bg-canvas text-foreground", className)}
      {...props}
    />
  );
}

function AppShellMain({ className, ...props }: React.ComponentProps<"main">) {
  return (
    <main
      data-slot="app-shell-main"
      className={cn("mx-auto flex w-full max-w-screen-2xl flex-1 flex-col px-4 pb-10 sm:px-6", className)}
      {...props}
    />
  );
}

function AppShellContent({
  size = "narrow",
  className,
  ...props
}: React.ComponentProps<"div"> & { size?: "narrow" | "wide" }) {
  return (
    <div
      data-slot="app-shell-content"
      data-size={size}
      className={cn("mx-auto w-full max-w-[40rem] data-[size=wide]:max-w-[60rem]", className)}
      {...props}
    />
  );
}

function AppShellPanels({ className, children, ...props }: React.ComponentProps<"div">) {
  return (
    <div data-slot="app-shell-panels" className="flex min-w-0 flex-1 px-4" {...props}>
      <div data-slot="app-shell-panels-layout" className={cn("flex min-w-0 flex-1 gap-4", className)}>
        {children}
      </div>
    </div>
  );
}

function AppShellCenter({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div data-slot="app-shell-center" className={cn("flex min-w-0 flex-1 justify-center", className)} {...props} />
  );
}

function AppShellAside({ className, ...props }: React.ComponentProps<"div">) {
  // display: contents lets panels hidden at a breakpoint drop out of the row's gap
  return <div data-slot="app-shell-aside" className={cn("contents", className)} {...props} />;
}

export { AppShell, AppShellMain, AppShellContent, AppShellPanels, AppShellCenter, AppShellAside };
